import './style.scss';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';
import { Accessibility } from '../../../../utils/Accessibility/Accessibility';
import ReactComponent from '../../../ReactComponent';
import { AppRouter } from '../../../../router/AppRouter';

export enum PrefTypes {
  social = 'social',
  message = 'message',
}

export default class NotificationPreferencesPanel extends UIObject {
  mDiv: JQuery<HTMLElement>;
  mConstructorParams: any;
  private _currentSite = -1;
  private _userPreferences: any;
  private _messagePrefs: [];
  private _socialPrefs: [];
  private _reactComponents = [];

  constructor() {
    super();
  }
  initialize(aConstructorParams) {
    this.mConstructorParams = aConstructorParams;
    super.initialize(aConstructorParams);

    this.mDiv = this._generateHtml();
    this._addEventListeners();
    this._getData().then(aResponse => {
      if (aResponse.preferences) {
        this._userPreferences = aResponse.preferences;
        this._messagePrefs = this._userPreferences.all_prefs?.filter(pref => {
          return pref.type === PrefTypes.message;
        });
        this._socialPrefs = this._userPreferences.all_prefs?.filter(pref => {
          return pref.type === PrefTypes.social;
        });
        this._loadData();
      }
    });
  }
  private _loadData() {
    App.INSTANCE.CurrentUser.updatePreferences(this._userPreferences.user_prefs);
    this._addSiteInfo();
    this._addPrefModule();
    if (this._messagePrefs.length == 0) {
      this.mDiv.find('.message_prefs').hide();
    }
    if (this._socialPrefs.length == 0) {
      this.mDiv.find('.social_prefs').hide();
    }
    if (this._userPreferences.all_prefs?.length == 0) {
      this.mDiv.find('.panel_body').hide();
      this.mDiv.find('.notice').html(CrowdHub_App.LANG.ADMIN_NOTIFICATION_PREFS_NOTAVAILABLE);
    }
  }
  private _addSiteInfo() {
    let aDiv = $('<div></div>');
    let aSelect = new ReactComponent();
    let aOptions = [];
    this._currentSite = this._userPreferences.sites[0]?.theme_id;
    this._userPreferences.sites?.forEach(site => {
      aOptions.push({
        value: site.theme_id,
        name: site.theme_name,
      });
    });
    aSelect.inject('JUNOSelect', aDiv, {
      options: aOptions,
      onChange: aValue => {
        this._currentSite = aValue;
        this._getData(aValue).then(aResponse => {
          this.mDiv.find('.message_pref_switches').empty();
          this.mDiv.find('.social_pref_switches').empty();
          this._userPreferences = aResponse.preferences;
          this._addPrefModule();
        });
      },
      placeHolder: '',
    });
    this.mDiv.find('.site_prefs .select_container').append(aSelect.mDiv);
    this._reactComponents.push(aSelect);
  }
  private _getData(aSiteId = window.PLATFORM_DATA.Platform.Sites[0].Id) {
    return new Promise<null>((resolve, reject) => {
      let aUrl = '../custom_api/api_Services_Notifications.php';
      let aVars = {
        api: 'api_get_notification_prefs_for_user',
        site_id: aSiteId,
      };
      App.INSTANCE.mApi.Request(
        aUrl,
        aVars,
        aData => {
          resolve(aData);
        },
        aError => {
          console.error(aError);
          reject(aError);
        },
      );
    });
  }
  private _addPrefModule() {
    this._userPreferences.all_prefs?.forEach(pref => {
      let aDiv = $('<div></div>');
      let prefModule = new ReactComponent();
      prefModule.inject('NotificationPrefModule', aDiv, {
        preference: pref,
        userPreferences: App.INSTANCE.CurrentUser.getNotificationPreferences(),
        handleChange: checked => {
          this._updateUserPreference({ preference: pref, checked: checked }, true);
        },
        updateUserPreference: props => {
          this._updateUserPreference(props);
        },
      });
      switch (pref.type) {
        case PrefTypes.message:
          this.mDiv.find('.message_pref_switches').append(prefModule.mDiv);
          break;
        case PrefTypes.social:
          this.mDiv.find('.social_pref_switches').append(prefModule.mDiv);
          break;
      }
      this._reactComponents.push(prefModule);
    });
  }

  private _updateUserPreference(props, isPreferred = false) {
    let aUrl = '../custom_api/api_Services_Notifications.php';
    let aVars = {
      api: 'api_update_notification_prefs_for_user',
      preference: props.preference?.id,
      option: props.type,
      checked: props.checked,
      site_id: this._currentSite,
      preferred: isPreferred,
    };
    App.INSTANCE.mApi.Request(
      aUrl,
      aVars,
      aData => {
        if (aData.preferences) {
          this._userPreferences = aData.preferences;
          App.INSTANCE.CurrentUser.updatePreferences(aData.preferences.user_prefs);
        }
      },
      aError => {},
    );
  }
  private _addEventListeners() {
    Accessibility.clickAndKeypress(this.mDiv.find('.panel_close'), () => {
      this.onHide();
    });

    Accessibility.clickAndKeypress(this.mDiv.find('.mobile_close'), () => {
      this.onHide();
    });

    Accessibility.clickAndKeypress(this.mDiv.find('.panel_content'), event => {
      event.stopPropagation();
      Accessibility.actionMenuOpen = false;
    });

    Accessibility.clickAndKeypress(this.mDiv.find('.panel_body'), event => {
      event.stopPropagation();
    });

    Accessibility.clickAndKeypress(this.mDiv, () => {
      // this stops the panel from closing if we had an action menu open
      if (Accessibility.actionMenuOpen == true) {
        Accessibility.actionMenuOpen = false;
        return;
      }
      this.onHide();
    });

    App.INSTANCE.addEventListener(
      AppRouter.ROUTEREVENT_ONROUTERBEFORE,
      () => {
        if (this.mConstructorParams.onHide != null) {
          this.mConstructorParams.onHide(this);
        }
      },
      this,
    );
  }

  private _generateHtml(): JQuery<HTMLElement> {
    return $(
      HGEN.tree({
        style: 'notification_panel notification_preferences_panel',
        children: [
          {
            style: 'panel_container',
            children: [
              {
                style: 'panel_close',
                interior: `Close ${HGEN.faicon({ style: FontAwesomeConfigurations.ICON_XMARK })}`,
              },
              {
                style: 'panel_content device_padding_topinset',
                children: [
                  {
                    style: 'panel_header',
                    children: [
                      {
                        style: 'panel_title',
                        children: [
                          {
                            style: 'mobile_close',
                            interior: HGEN.faicon({ style: FontAwesomeConfigurations.ICON_CHEVRON_DOWN }),
                          },
                          { style: 'title', interior: 'Notification Preferences' },
                        ],
                      },
                      {
                        style: 'notice',
                        interior: CrowdHub_App.LANG.PREFS_PANEL_SUBTITLE,
                      },
                    ],
                  },
                  {
                    style: 'panel_body',
                    children: [
                      {
                        style: 'site_prefs',
                        children: [
                          { style: '', interior: CrowdHub_App.LANG.PREFS_PANEL_SITE_TEXT },
                          { style: 'select_container' },
                        ],
                      },
                      {
                        style: 'message_prefs',
                        children: [
                          {
                            style: 'subtitle margin_bottom_big',
                            interior:
                              HGEN.faicon({ style: FontAwesomeConfigurations.ICON_COMMENT_LINES_SOLID }) +
                              'Message Alerts',
                          },
                          { style: 'message_pref_switches' },
                        ],
                      },
                      {
                        style: 'social_prefs',
                        children: [
                          {
                            style: 'subtitle margin_top_big margin_bottom',
                            interior:
                              HGEN.faicon({ style: FontAwesomeConfigurations.ICON_MESSAGE_LINES_SOLID }) +
                              'Feed & Forum Notifications',
                          },
                          { style: 'social_pref_switches' },
                        ],
                      },
                    ],
                  },
                  { style: 'panel_footer' },
                ],
              },
            ],
          },
        ],
      }),
    );
  }
  onHide() {
    if (this.mConstructorParams.onHide != null) {
      this.mConstructorParams.onHide(this);
    }
    App.INSTANCE.safelyGoBack();
  }
  onTransitionIn() {}
  onTransitionOut() {
    App.INSTANCE.removeEventListenerByScope(AppRouter.ROUTEREVENT_ONROUTERBEFORE, this);
    this._reactComponents.forEach(reactComponent => {
      reactComponent.destroy();
    });
  }
  destroy() {}
}
